import { render, staticRenderFns } from "./ShoppingGame.vue?vue&type=template&id=5ea698cc&"
import script from "./ShoppingGame.vue?vue&type=script&lang=js&"
export * from "./ShoppingGame.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports